<template>
  <div class="page" :style="themeStyle">
    <div v-if="!loaded" class="loading">Loading</div>
    <div v-if="loaded" class="root">

      <!-- Left full-bleed dark panel -->
      <div class="left-panel">
        <div class="lp-pattern" aria-hidden="true"></div>
        <div class="lp-content">
          <img v-if="loinfo && loinfo.main_logo" :src="loinfo.main_logo" class="lp-logo" />
          <div class="lp-divider"></div>
          <h1 class="lp-h1" v-html="heroH1Html"></h1>
          <p class="lp-body">{{ heroBody }}</p>
          <div class="lp-actions">
            <a class="lp-btn" :href="applyRightLink">{{ heroPrimaryText }}</a>
            <a v-if="applyLeftLink" class="lp-btn-ghost" :href="applyLeftLink">{{ heroSecondaryText }}</a>
          </div>
          <div class="lp-contacts">
            <a v-if="loinfo && loinfo.phone_number" :href="'tel:' + loinfo.phone_number" class="lp-contact">{{ loinfo.phone_number }}</a>
            <a v-if="loinfo && loinfo.email" :href="'mailto:' + loinfo.email" class="lp-contact">{{ loinfo.email }}</a>
          </div>
        </div>
        <!-- Vertical label -->
        <div class="lp-vert-label">MORTGAGE PARTNERSHIP</div>
      </div>

      <!-- Right light panel -->
      <div class="right-panel">
        <div class="rp-header">
          <span class="rp-kicker">Your Team</span>
       
        </div>

        <div class="agent-block lo-agent">
          <div class="ab-accent lo-accent"></div>
          <div class="ab-top">
            <img v-if="loinfo && loinfo.lo_image" :src="loinfo.lo_image" class="ab-photo" />
            <div class="ab-meta">
              <span class="ab-label">Loan Officer</span>
              <div class="ab-name">{{ loName }}</div>
              <div class="ab-role">{{ loTitle }}</div>
              <div v-if="loinfo && loinfo.nmls" class="ab-nmls">NMLS {{ (loinfo.nmls || "").trim() }}</div>
            </div>
          </div>
          <div class="ab-links">
            <a v-if="loinfo && loinfo.phone_number" :href="'tel:' + loinfo.phone_number" class="ab-link lo-link">{{ loinfo.phone_number }}</a>
            <a v-if="loinfo && loinfo.email" :href="'mailto:' + loinfo.email" class="ab-link lo-link">{{ loinfo.email }}</a>
          </div>
      
        </div>

        <div class="agent-block re-agent">
          <div class="ab-accent re-accent"></div>
          <div class="ab-top">
            <img v-if="realtor && realtor.headshot_url" :src="realtor.headshot_url" class="ab-photo" />
            <div class="ab-meta">
              <span class="ab-label re-label-txt">{{ realtor?.partner_title || 'Partner' }}</span>
              <div class="ab-name">{{ realtorName }}</div>
              <div class="ab-role">{{ realtor && realtor.brokerage_name }}</div>
              <div v-if="realtor && realtor.nmls" class="ab-nmls">NMLS {{ (realtor.nmls || "").trim() }}</div>
            </div>
          </div>
          <div class="ab-links">
            <a v-if="realtor && realtor.phone_number" :href="'tel:' + realtor.phone_number" class="ab-link re-link">{{ realtor.phone_number }}</a>
            <a v-if="realtor && realtor.email" :href="'mailto:' + realtor.email" class="ab-link re-link">{{ realtor.email }}</a>
            <a v-if="realtor && realtor.website_url" :href="realtor.website_url" class="ab-link re-link" target="_blank" rel="noreferrer">Website →</a>
          </div>
        </div>

        <div class="rp-footer">
          <span class="rp-footer-text">{{ loName }} · {{ loTitle }}</span>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import coBrandMixin from "../../mixins/coBrandMixin.js";
const BRAND_COLORS = {
  zonalending: { primary: "#eb610a", accent: "#646363" },
  radiantmortgage: { primary: "#1C1F39", accent: "#DB9457" },
  conradmortgage: { primary: "#4a4b4b", accent: "#d4af37" },
  theimgteam: { primary: "#ff6633", accent: "#4a4c54" },
  responsivemortgage: { primary: "#07212c", accent: "#FF7F47" },
  kpmortgage: { primary: "#0D2821", accent: "#34BFC6" },
  ignitemortgage: { primary: "#000000", accent: "#00b1eb" },
  goldstarfinancial: { primary: "#0b1726", accent: "#c69c39" },
};
function getBrandKey(email) {
  if (!email) return null;
  return email.slice(email.indexOf("@") + 1).toLowerCase().split(".")[0] || null;
}
export default {
  name: "CoBrandMidnight",
  mixins: [coBrandMixin],
  computed: {
    brandKey() { const k = getBrandKey(this.loinfo?.email); return (k && BRAND_COLORS[k]) ? k : "goldstarfinancial"; },
    palette() { return BRAND_COLORS[this.brandKey] || BRAND_COLORS.goldstarfinancial; },
    themeStyle() { return { "--p": this.palette.primary, "--a": this.palette.accent }; },
    heroH1Html() {
      const h = (this.realtor?.header1 || this.loinfo?.header1 || "").trim();
      if (!h) return "Your home,<br/><em>your future.</em>";
      const parts = h.split(",");
      if (parts.length > 1) return `${parts[0].trim()}<br/><em>${parts.slice(1).join(",").trim()}</em>`;
      return h;
    },
    heroPrimaryText() { return this.loinfo?.right_button_text || "Apply Now"; },
    heroSecondaryText() { return this.loinfo?.left_button_text || "Schedule Appointment"; },
    heroBody() {
      const m = (this.realtor?.main || this.loinfo?.main || "").trim();
      if (m) return m;
      return [this.loinfo?.text_section_body_p1, this.loinfo?.text_section_body_p2].filter(Boolean).join(" ").trim()
        || this.loinfo?.footer_slogan || "Start your application in minutes and we'll guide you from application through closing.";
    },
  }
};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Cormorant+Garamond:ital,wght@0,400;0,600;1,400;1,600&family=Jost:wght@300;400;500;600&display=swap');

.page {
  min-height: 100vh;
  background: #0a0c10;
  color: #1a1c22;
  font-family: 'Jost', sans-serif;
  --p: #0b1726;
  --a: #c69c39;
  --bg-light: #f9f8f6;
  --border: rgba(26,28,34,0.12);
  --muted: #6b7180;
  --a-glow: color-mix(in srgb, var(--a) 35%, transparent);
}
.root { display: flex; min-height: 100vh; }

/* LEFT PANEL */
.left-panel {
  width: 45%;
  background: var(--p);
  position: relative;
  overflow: hidden;
  display: flex;
  align-items: stretch;
  flex-direction: column;
  justify-content: center;
}
.lp-pattern {
  position: absolute; inset: 0;
  background-image:
    radial-gradient(circle at 20% 20%, color-mix(in srgb, var(--a) 12%, transparent) 0%, transparent 50%),
    radial-gradient(circle at 80% 80%, color-mix(in srgb, var(--a) 8%, transparent) 0%, transparent 40%);
}
.lp-content { position: relative; z-index: 1; padding: 60px 52px; flex: 1; display: flex; flex-direction: column; justify-content: center; }
.lp-logo { width: 160px; max-height:80px; object-fit: contain; filter: brightness(0) invert(1); opacity: 0.85; margin-bottom: 32px; }
.lp-divider { width: 40px; height: 2px; background: var(--a); margin-bottom: 32px; }
.lp-h1 { font-family: 'Cormorant Garamond', serif; font-size: clamp(36px, 4vw, 58px); font-weight: 600; line-height: 1.1; color: #f5f0e8; margin: 0 0 22px; }
.lp-h1 em { font-style: italic; color: var(--a); font-weight: 400; }
.lp-body { font-size: 14px; line-height: 1.8; color: rgba(245,240,232,0.55); margin-bottom: 36px; font-weight: 300; }
.lp-actions { display: flex; flex-direction: column; gap: 10px; margin-bottom: 28px; }
.lp-btn { font-size: 12px; font-weight: 600; text-decoration: none; background: var(--a); color: var(--p); padding: 14px 28px; border-radius: 6px; text-align: center; transition: opacity 0.2s; letter-spacing: 0.04em; }
.lp-btn:hover { opacity: 0.88; }
.lp-btn-ghost { font-size: 12px; font-weight: 400; text-decoration: none; color: rgba(245,240,232,0.5); border: 1px solid rgba(255,255,255,0.12); padding: 13px 28px; border-radius: 6px; text-align: center; transition: border-color 0.18s; }
.lp-btn-ghost:hover { border-color: rgba(255,255,255,0.28); }
.lp-contacts { display: flex; flex-direction: column; gap: 6px; }
.lp-contact { font-size: 11px; text-decoration: none; color: rgba(245,240,232,0.4); transition: color 0.18s; }
.lp-contact:hover { color: var(--a); }
.lp-vert-label { position: absolute; bottom: 52px; right: -28px; font-size: 9px; font-weight: 600; letter-spacing: 0.3em; text-transform: uppercase; color: rgba(255,255,255,0.12); transform: rotate(-90deg); white-space: nowrap; }

/* RIGHT PANEL */
.right-panel { flex: 1; background: var(--bg-light); display: flex; flex-direction: column; padding: 0; }
.rp-header { display: flex; align-items: center; justify-content: space-between; padding: 20px 40px; border-bottom: 1px solid var(--border); }
.rp-kicker { font-size: 10px; font-weight: 600; letter-spacing: 0.22em; text-transform: uppercase; color: var(--muted); }
.rp-nav-cta { font-size: 12px; font-weight: 600; text-decoration: none; background: var(--p); color: #fff; padding: 9px 20px; border-radius: 6px; transition: opacity 0.2s; }
.rp-nav-cta:hover { opacity: 0.88; }
.agent-block { padding: 32px 40px; border-bottom: 1px solid var(--border); position: relative; overflow: hidden; }
.ab-accent { position: absolute; top: 0; left: 40px; right: 40px; height: 2px; }
.lo-accent { background: linear-gradient(90deg, var(--p), transparent); }
.re-accent { background: linear-gradient(90deg, var(--a), transparent); }
.ab-top { display: flex; gap: 16px; align-items: flex-start; margin-bottom: 16px; }
.ab-photo { width: 64px; border-radius: 12px; object-fit: cover; flex-shrink: 0; box-shadow: 0 4px 16px rgba(0,0,0,0.12); }
.ab-label { font-size: 9px; font-weight: 600; letter-spacing: 0.2em; text-transform: uppercase; color: var(--p); display: block; margin-bottom: 4px; }
.re-label-txt { color: color-mix(in srgb, var(--a) 80%, #1a1c22); }
.ab-name { font-family: 'Cormorant Garamond', serif; font-size: 22px; font-weight: 600; color: #1a1c22; line-height: 1.2; }
.ab-role { font-size: 11px; color: var(--muted); }
.ab-nmls { font-size: 10px; color: color-mix(in srgb, var(--muted) 65%, transparent); margin-top: 2px; }
.ab-links { display: flex; flex-direction: column; gap: 4px; margin-bottom: 14px; }
.ab-link { font-size: 11px; text-decoration: none; color: var(--muted); transition: color 0.18s; }
.lo-link:hover { color: var(--p); }
.re-link:hover { color: color-mix(in srgb, var(--a) 80%, #1a1c22); }
.ab-cta { display: block; text-align: center; text-decoration: none; font-size: 12px; font-weight: 600; padding: 11px; border-radius: 7px; background: var(--p); color: #fff; transition: opacity 0.2s; }
.ab-cta:hover { opacity: 0.88; }
.rp-footer { padding: 20px 40px; margin-top: auto; }
.rp-footer-text { font-size: 11px; color: var(--muted); }

@media (max-width: 820px) {
  .root { flex-direction: column; }
  .left-panel { width: 100%; }
  .lp-vert-label { display: none; }
  .rp-header { padding: 16px 24px; }
  .agent-block { padding: 24px; }
  .rp-footer { padding: 16px 24px; }
}
</style>
